import { Box, CircularProgress, IconButton, Stack, Typography } from '@mui/material'
import HighchartsReact from 'highcharts-react-official'
import React from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import DarkUnica from 'highcharts/themes/dark-unica'
import { useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import * as HighCharts from 'highcharts'
import { generateAssetPerformanceChartOptions } from './ChartOptions'
import moment from 'moment-timezone'
import AuthError from '../../../components/ErrorComponents/AuthError'

interface Device {
  registerReadings: Array<{
    cimCodeId: string
    units: string
    latestValue: number
    registerName: string
    alarmLowerLimit: number
    alarmHigherLimit: number
    deviceName: string
    registerReadings: Array<{ readingTime: string, value: number, indexValue: number }>
  }>
}

interface kpiDevice {
  kpiReadings: Array<{
    kpiName: string
    latestValue: number
    units: string
    alarmLowerLimit: number
    alarmHigherLimit: number
    kpiReadings: Array<{ value: number, readingTime: string }>
  }>
}

const Performance = (props: AllProps): JSX.Element => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const perFormanceRegisterData = useSelector((state: RootState) => state.assetPerformanceData)
  const PerFormanceKPIData = useSelector((state: RootState) => state.AssetPerformanceKPIData)
  DarkUnica(HighCharts)
  const chartData = Array.isArray(perFormanceRegisterData.AssetPerformanceData)
    ? perFormanceRegisterData.AssetPerformanceData.flatMap((device: Device) =>
      device.registerReadings.map((reading: { registerName: string, latestValue: number, units: string, alarmLowerLimit: number, alarmHigherLimit: number, deviceName: string, registerReadings: Array<{ value: number, indexValue: number, readingTime: string }> }) => ({
        label: reading.registerName,
        value: `${reading.latestValue} ${reading.units === null ? '' : reading.units}`,
        LowerLimit: reading.alarmLowerLimit,
        HigherLimit: reading.alarmHigherLimit,
        deviceName: reading.deviceName,
        data: reading.registerReadings.map((readingData: { value: number, indexValue: number, readingTime: string }) => ({
          value: readingData.indexValue,
          readingTime: readingData.readingTime !== '' ? moment.utc(readingData.readingTime).tz(userTimezone).format('YYYY-MM-DD hh:mm:ss A') : 'N/A' // Provide a default if readingTime is not available
        }))
      }))
    )
    : []

  const chartKPIData = Array.isArray(PerFormanceKPIData.AssetPerformanceKPIData?.deviceKPIReadings)
    ? PerFormanceKPIData.AssetPerformanceKPIData?.deviceKPIReadings.flatMap((device: kpiDevice) =>
      device.kpiReadings.map((reading: { kpiName: string, latestValue: number, units: string, alarmLowerLimit: number, alarmHigherLimit: number, kpiReadings: Array<{ value: number, readingTime: string }> }) => ({
        label: reading.kpiName,
        value: `${reading.latestValue} ${reading.units === null ? '' : reading.units}`,
        LowerLimit: reading.alarmLowerLimit,
        HigherLimit: reading.alarmHigherLimit,
        data: reading.kpiReadings.map((readingData: { value: number, readingTime: string }) => ({
          value: readingData.value,
          readingTime: readingData.readingTime !== '' ? moment.utc(readingData.readingTime).tz(userTimezone).format('YYYY-MM-DD hh:mm:ss A') : 'N/A' // Provide a default if readingTime is not available
        }))
      }))
    )
    : []

  const chartAssetKPIData = Array.isArray(PerFormanceKPIData.AssetPerformanceKPIData?.assetKPIReadings)
    ? PerFormanceKPIData.AssetPerformanceKPIData?.assetKPIReadings.flatMap((device: kpiDevice) =>
      device.kpiReadings.map((reading: { kpiName: string, latestValue: number, units: string, alarmLowerLimit: number, alarmHigherLimit: number, kpiReadings: Array<{ value: number, readingTime: string }> }) => ({
        label: reading.kpiName,
        value: `${reading.latestValue} ${reading.units === null ? '' : reading.units}`,
        LowerLimit: reading.alarmLowerLimit,
        HigherLimit: reading.alarmHigherLimit,
        data: reading.kpiReadings.map((readingData: { value: number, readingTime: string }) => ({
          value: readingData.value,
          readingTime: readingData.readingTime !== '' ? moment.utc(readingData.readingTime).tz(userTimezone).format('YYYY-MM-DD hh:mm:ss A') : 'N/A' // Provide a default if readingTime is not available
        }))
      }))
    )
    : []

  return (<>
     <Box sx={{ backgroundColor: '#2d2d2d', borderRadius: 2, padding: 2, color: '#fff', height: '980px', overflow: 'auto' }}>
              <Typography className='title-box' variant="h6" sx={{ marginBottom: 3 }}>Last 60 Minutes Performance</Typography>
              <div className='performance-header-icon' style={{ float: 'right', justifyContent: 'space-between' }}>
                <IconButton onClick={props.setIsModalOpenPerformance}>
                  <MoreVertIcon />
                </IconButton>
                {props.dialogParameterSelection(props.isModalOpenPerformance, 'assetPerformance')}
              </div>
              {
              perFormanceRegisterData.isLoading
                ? <div style={{ display: 'flex', justifyContent: 'center' }} ><CircularProgress /></div>
                : (perFormanceRegisterData.httpStatus === 404 && PerFormanceKPIData.httpStatus === 404) || (perFormanceRegisterData.httpStatus === 500 || PerFormanceKPIData.httpStatus === 500) || (perFormanceRegisterData.httpStatus === 204 || PerFormanceKPIData.httpStatus === 204)
                    ? <div style={{ display: 'flex', height: '350px', justifyContent: 'center', alignItems: 'center', color: '#f0f0f0' }}>
                    <AuthError
                      className='alertTrendError'
                      errorMessage='NoDataPresentPerformanceGraph'
                    /></div>
                    : (chartData.length === 0 && chartKPIData?.length === 0 && chartAssetKPIData?.length === 0)
                        ? <div style={{ height: '40px', marginTop: '22px', color: '#cacaca' }} >No Chart Data Available</div>
                        : <Stack spacing={2} style={{ overflowY: 'auto' }} >
                          {chartData.map((item, index) => (
                            <React.Fragment key={index}>
                              <Stack direction="row" justifyContent="flex-start" alignItems="center">
                                <Typography sx={{ fontSize: '16px', color: '#D0D0D0', marginRight: '10px' }} variant="body2">
                                  {item.label}
                                </Typography>
                                <Typography variant="h6" sx={{ fontSize: '20px', color: '#D0D0D0' }}>
                                  {item.value}
                                </Typography>
                              </Stack>
                              <div style={{ marginTop: '0px' }} >
                                { item.data.length < 1
                                  ? <div style={{ height: '40px', marginTop: '22px', color: '#cacaca' }} >No Data Found</div>
                                  : <HighchartsReact
                                      highcharts={HighCharts}
                                      options={generateAssetPerformanceChartOptions(item.data, item.LowerLimit, item.HigherLimit, '#707070', item.label)}
                                    />
                                }
                              </div>
                            </React.Fragment>
                          ))}
                          {chartKPIData?.map((item, index) => (
                            <React.Fragment key={index}>
                              <Stack direction="row" justifyContent="flex-start" alignItems="center">
                                <Typography sx={{ fontSize: '16px', color: '#D0D0D0', marginRight: '10px' }} variant="body2">
                                  {item.label}
                                </Typography>
                                <Typography variant="h6" sx={{ fontSize: '20px', color: '#D0D0D0' }}>
                                {item.value}
                                </Typography>
                              </Stack>
                              <div style={{ marginTop: '0px' }} >
                                { item.data.length < 1
                                  ? <div style={{ height: '40px', marginTop: '22px', color: '#cacaca' }} >No Data Found</div>
                                  : <HighchartsReact
                                      highcharts={HighCharts}
                                      options={generateAssetPerformanceChartOptions(item.data, item.LowerLimit, item.HigherLimit, '#707070', item.label)}
                                    />
                                }
                              </div>
                            </React.Fragment>
                          ))}
                          {chartAssetKPIData?.map((item, index) => (
                            <React.Fragment key={index}>
                              <Stack direction="row" justifyContent="flex-start" alignItems="center">
                                <Typography sx={{ fontSize: '16px', color: '#D0D0D0', marginRight: '10px' }} variant="body2">
                                  {item.label}
                                </Typography>
                                <Typography variant="h6" sx={{ fontSize: '20px', color: '#D0D0D0' }}>
                                {item.value}
                                </Typography>
                              </Stack>
                              <div style={{ marginTop: '0px' }} >
                                { item.data.length < 1
                                  ? <div style={{ height: '40px', marginTop: '22px', color: '#cacaca' }} >No Data Found</div>
                                  : <HighchartsReact
                                      highcharts={HighCharts}
                                      options={generateAssetPerformanceChartOptions(item.data, item.LowerLimit, item.HigherLimit, '#707070', item.label)}
                                    />
                                }
                              </div>
                            </React.Fragment>
                          ))}
                          </Stack>
              }
          </Box>
  </>)
}

interface InputProps {
  isModalOpenPerformance: boolean
  dialogParameterSelection: any
  setIsModalOpenPerformance: any
}

type AllProps = InputProps

export const MemoPerformance = React.memo(Performance)
